export const REGULAR_ACCOUNT = 'REGULAR';
export const PARENT_ACCOUNT = 'PARENT';
export const CHILD_ACCOUNT = 'CHILD';
export const CUSTOMER_SUB_TYPE_XL = 'XL'
export const CUSTOMER_SUB_TYPE_ZL = 'ZL'
export const CUSTOMER_TYPE_AMAZON_DSP = 'Amazon DSP'
export const ACCOUNT_COUNTRY_DEFAULT = 'USA'
export const CUSTOMER_STATUS = [
    'Active - Bundle',
    'Active - Premium',
    'Active - Standard',
    'Churned',
    'Lapsed Trial',
    'Trial',
    'Trial (Plan Selected)',
    'Unknown'
]
export const CUSTOMER_TYPE = [CUSTOMER_TYPE_AMAZON_DSP,'FedEx ISP'];
export const CUSTOMER_SUBTYPE = ['ZL','XL','Regular', 'Lite'];
export const CUSTOMER_TYPE_SUBTYPE_AMAZON_DSP = ['ZL','XL', 'Lite'];
export const CUSTOMER_TYPE_SUBTYPE_FEDEX_ISP = ['Regular'];
export const ACCOUNT_COUNTRY = ['USA','Canada','UK','Australia'];
export const ACCOUNT_TIME = ['Permanent','Temporary'];
export const ACCOUNT_TESTING = ['Yes','No'];
export const FEATURE_ACCESS_PERMISSION_FILL = {
    featureAccessVehiclePhotoLogsHeraAi: 'Vehicle Management: Vehicle Photo Logs Hera AI',
    featureAccessVehiclePhotoLogReview: 'Vehicle Management: Vehicle Photo Log Review',
    featureAccessInventoryManagement: 'Inventory Management',
    featureAccessRosterChecklist: 'Roster Checklist',
    featureAccessWirelessSupportSync: 'Wireless Support Sync',
    featureAccessDeviceManagementV2: 'Device Management v2',
    featureAccessCustomEmailSending: 'Custom Email Sending',
    featureAccessHeraMessenger2: 'Hera Messenger 2',
    featureAccessPhoneAutomation: 'Phone Automation',
    featureAccessAssociateApp:'Associate App',
    featureAccessAIChat: 'Hera AI Chat',
    featureAccessAmazonChromePlugin: 'Hera Amazon Chrome Plugin',
    featureAccessFilesManagement: 'File Management',
    featureAccessFilesSignatureRequest: 'Signature Requests',
    featureAccessHierarchicalPermissions: 'Hierarchical Permissions',
    featureAccessChecklistsAndVehiclePhotoLogs: 'Checklists & Vehicle Photo Logs',
    featureAccessPayrollProvider: 'Payroll Provider',
    featureAccessSchedulingAndRostering: 'Scheduling & Rostering'
};
export const FEATURE_ENABLED_PERMISSION_FILL= {
    featureEnabledVehiclePhotoLogsHeraAi: 'Vehicle Management: Vehicle Photo Logs Hera AI',
    featureEnabledVehiclePhotoLogReview: 'Vehicle Management: Vehicle Photo Log Review',
    featureEnabledInventoryManagement: 'Inventory Management',
    featureEnabledRosterChecklist: 'Roster Checklist',
    featureEnabledWirelessSupportSync: 'Wireless Support Sync',
    featureEnabledDeviceManagementV2: 'Device Management v2',
    featureEnabledCustomEmailSending: 'Custom Email Sending',
    featureEnabledHeraMessenger2: 'Hera Messenger 2',
    featureEnabledPhoneAutomation: 'Phone Automation',
    featureEnabledAssociateApp:'Associate App',
    featureEnabledAIChat: 'Hera AI Chat',
    featureEnabledAmazonChromePlugin: 'Hera Amazon Chrome Plugin',
    featureEnabledFilesManagement: 'File Management',
    featureEnabledFilesSignatureRequest: 'Signature Requests',
    featureEnabledHierarchicalPermissions: 'Hierarchical Permissions',
    featureEnabledChecklistsAndVehiclePhotoLogs: 'Checklists & Vehicle Photo Logs',
    featureEnabledPayrollProvider: 'Payroll Provider',
    featureEnabledSchedulingAndRostering: 'Scheduling & Rostering',
};
export const FEATURES_ACCESS_PERMISSIONS = ['Vehicle Management: Vehicle Photo Logs Hera AI (ON)',
                                            'Vehicle Management: Vehicle Photo Logs Hera AI (OFF)',
                                            'Vehicle Management: Vehicle Photo Log Review (ON)',
                                            'Vehicle Management: Vehicle Photo Log Review (OFF)',
                                            'Inventory Management (ON)',
                                            'Inventory Management (OFF)',
                                            'Roster Checklist (ON)',
                                            'Roster Checklist (OFF)',
                                            'Wireless Support Sync (ON)',
                                            'Wireless Support Sync (OFF)',
                                            'Device Management v2 (ON)',
                                            'Device Management v2 (OFF)',
                                            'Custom Email Sending (ON)',
                                            'Custom Email Sending (OFF)',
                                            'Associate App (ON)',
                                            'Associate App (OFF)',
                                            'Hera Messenger 2 (ON)',
                                            'Hera Messenger 2 (OFF)',
                                            'Phone Automation (ON)',
                                            'Phone Automation (OFF)',
                                            'Hera AI Chat (ON)',
                                            'Hera AI Chat (OFF)',
                                            'Hera Amazon Chrome Plugin (ON)',
                                            'Hera Amazon Chrome Plugin (OFF)',
                                            'Hierarchical Permissions (ON)',
                                            'Hierarchical Permissions (OFF)',
                                            'Checklists & Vehicle Photo Logs (ON)',
                                            'Checklists & Vehicle Photo Logs (OFF)',
                                            'Signature Requests (ON)',
                                            'Signature Requests (OFF)',
                                            'Payroll Provider (ON)',
                                            'Payroll Provider (OFF)',
                                            'Scheduling & Rostering (ON)',
                                            'Scheduling & Rostering (OFF)',
                                        ];
export const FEATURES_ENABLED_PERMISSIONS = ['Vehicle Management: Vehicle Photo Logs Hera AI (Enabled)',
                                            'Vehicle Management: Vehicle Photo Logs Hera AI (Disabled)',
                                            'Vehicle Management: Vehicle Photo Log Review (Enabled)',
                                            'Vehicle Management: Vehicle Photo Log Review (Disabled)',
                                            'Inventory Management (Enabled)',
                                            'Inventory Management (Disabled)',
                                            'Roster Checklist (Enabled)',
                                            'Roster Checklist (Disabled)',
                                            'Wireless Support Sync (Enabled)',
                                            'Wireless Support Sync (Disabled)',
                                            'Device Management v2 (Enabled)',
                                            'Device Management v2 (Disabled)',
                                            'Custom Email Sending (Enabled)',
                                            'Custom Email Sending (Disabled)',
                                            'Associate App (Enabled)',
                                            'Associate App (Disabled)',
                                            'Hera Messenger 2 (Enabled)',
                                            'Hera Messenger 2 (Disabled)',
                                            'Phone Automation (Enabled)',
                                            'Phone Automation (Disabled)',
                                            'Hera AI Chat (Enabled)',
                                            'Hera AI Chat (Disabled)',
                                            'Hera Amazon Chrome Plugin (Enabled)',
                                            'Hera Amazon Chrome Plugin (Disabled)',
                                            'Hierarchical Permissions (Enabled)',
                                            'Hierarchical Permissions (Disabled)',
                                            'Checklists & Vehicle Photo Logs (Enabled)',
                                            'Checklists & Vehicle Photo Logs (Disabled)',
                                            'Signature Requests (Enabled)',
                                            'Signature Requests (Disabled)',
                                            'Payroll Provider (Enabled)',
                                            'Payroll Provider (Disabled)',
                                            'Scheduling & Rostering (Enabled)',
                                            'Scheduling & Rostering (Disabled)',
                                        ];
export const ABBREVATION_MAP_FEATURES = {
                                        'Vehicle Management: Vehicle Photo Log Review': 'VPLR',
                                        'Vehicle Management': 'VPLAI',
                                        'Inventory Management': 'IM',
                                        'Roster Checklist': 'RCL',
                                        'Hera Messenger 2': 'HeraMessenger2',
                                        'Phone Automation': 'PhoneAutomation',
                                        'Wireless Support Sync': 'WSI',
                                        'Device Management v2': 'DMV2',
                                        'Associate App': 'AA',
                                        'Custom Email Sending': 'CustomEmailSending',
                                        'Hera AI Chat': 'AIC',
                                        'Hera Amazon Chrome Plugin': 'ACP',
                                        'Hierarchical Permissions': 'HP',
                                        'Checklists & Vehicle Photo Logs': 'CVPL',
                                        'Signature Requests': 'FSR',
                                        'Payroll Provider': 'PP',
                                        'Scheduling & Rostering': 'SR'
                                        };
export const ACCOUNT_CANCELED_REASON = [
    "Cost Savings",
    "DeliverRE Partnership Ended",
    "Didn't Fully Utilize or Find Value",
    "Dropped Associates to 0",
    "DSP Closed",
    "Internal Processes in Use",
    "Leveraging Previous Internal Processes",
    "Non-Bundle Customer",
    "Pause Subscription",
    "Reduced Route Count",
    "Restructuring Internal Business Operations",
    "Secondary Site Closure",
    "Stopped Using - No Explanation",
    "Switched to Competitor - DSPworkplace",
    "Switched to Competitor - Drivr",
    "Switched to Competitor - LMDmax",
    "Switched to Competitor - Lokiteck",
    "Switched to Competitor - Manage my DSP",
    "Switched to Competitor - Other"
];
//Tenant Payroll Provider
export const PAYCOM = "PAYCOM";
export const ADP = "ADP";
export const UZIO = "UZIO";
export const BAMBOOHR = "BAMBOOHR";
export const TENANT_PAYROLL_PROVIDER_OPTIONS = [
    {
        value: PAYCOM,
        label: 'Paycom'
    },
    {
        value: ADP,
        label: 'ADP'
    },
    {
        value: UZIO,
        label: 'Uzio'
    },
    {
        value: BAMBOOHR,
        label: 'BambooHR'
    }
];
export const payrollProviderValueToLabel = {
    [PAYCOM]: 'Paycom',
    [ADP]: 'ADP',
    [UZIO]: 'Uzio',
    [BAMBOOHR]: 'BambooHR'
};
export const payrollProviderLabelToValue = {
    'Paycom': PAYCOM,
    'ADP': ADP,
    'UZIO': UZIO,
    'BambooHR': BAMBOOHR
};
export const TENANT_PAYROLL_PROVIDER_FILTERS = [ payrollProviderValueToLabel[PAYCOM], payrollProviderValueToLabel[ADP], payrollProviderValueToLabel[UZIO], payrollProviderValueToLabel[BAMBOOHR]];
